module.exports = __webpack_public_path__ + "static/media/house.e716f7c4.svg";